import { Table as TableIcon } from "lucide-react"; // ✅ Renamed to avoid conflict
import { Card, CardContent, CardHeader } from "./ui/card";
import { Skeleton } from "./ui/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "./ui/table";

interface LoadingTableProps {
  title?: string;
  count?: number;
  columns: string[];
  rows?: number;
  showPagination?: boolean;
}

const LoadingTable: React.FC<LoadingTableProps> = ({
  title = "Loading...",
  count = 0,
  columns,
  rows = 5,
  showPagination = true
}) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Skeleton className="h-6 w-32" />
          <span className="font-inter font-medium text-[16px] leading-[100%] tracking-normal text-[#758195]">
            ({count})
          </span>
        </div>
      </CardHeader>

      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                {columns.map((column, index) => (
                  <TableHead
                    key={index}
                    className="font-inter font-semibold text-[12px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]"
                  >
                    {column}
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {Array.from({ length: rows }).map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columns.map((_, colIndex) => (
                    <TableCell key={colIndex}>
                      <div className="flex flex-col gap-2">
                        <Skeleton className="h-4 w-full" />
                        {colIndex === 0 && (
                          <Skeleton className="h-3 w-3/4" />
                        )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        {showPagination && (
          <div className="mt-6 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Skeleton className="h-8 w-24" />
              <Skeleton className="h-8 w-16" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-8 w-8" />
              <Skeleton className="h-8 w-8" />
              <Skeleton className="h-8 w-8" />
              <Skeleton className="h-8 w-8" />
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default LoadingTable;
